export function getFileIngestModifiedAfterMs(
  sourceConfig: Record<string, unknown> | null | undefined,
): number | null {
  const modifiedAfterConfigValue = sourceConfig?.['ignore.files.older.than.ms'];

  if (
    modifiedAfterConfigValue === null ||
    modifiedAfterConfigValue === undefined ||
    modifiedAfterConfigValue === ''
  )
    return null;

  const normalizedModifiedAfterMs = Number(modifiedAfterConfigValue);

  if (!Number.isFinite(normalizedModifiedAfterMs)) return null;

  return normalizedModifiedAfterMs;
}
